import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { element } from 'protractor';
import { environment } from 'src/environments/environment';
import { AdminService } from '../services/admin.service';
import { ConstantsService } from '../services/constants.service';
import { DataService } from '../services/data.service';
import { UrlConstants } from '../services/url-constants';

@Component({
  selector: 'app-admin-gdrive',
  templateUrl: './admin-gdrive.component.html',
  styleUrls: ['./admin-gdrive.component.scss'],
})
export class AdminGdriveComponent implements OnInit {
  public sheetSelected = 'Google Form 1';
  public videoList = [];
  public selectedUrl;
  public selectedAuthor;
  public selectedCity;
  public selectedCountry;
  public selectedMessage;
  public selectedEmail;
  public seletecDateUploaded;
  public editTitle = false;
  public showVideo = false;
  public tags = this.constants.DEFAULT_TAGS;
  public uploadSubmit: UntypedFormGroup;
  public videoId;
  public uploadStatus = null
  tag = {
    Animal: false,
    Rain: false,
    Snow: false,
    City: false,
    Nature: false,
    Night: false,
    Day: false,
    Interior: false,
    Water: false,
  };
  rowIndex: any;
  skeltonArray: any[];
  isLoading: boolean = true;
  videoItem: any;
  rowIndexArray: any = [];
  enableDelete: boolean = false;
  uploadingToVimeo: boolean = false;
  videoDuration: number;
  availableSheets: any;
  savingEditedData: boolean = false;
  filteredString: string = '';
  showSuccessMessage: boolean = false;
  showErrorMessage: boolean;
  maxLimitReached: boolean = false;
  displaySuccessMessageDiv: any = false;
  clickedDeleteButton: boolean = false;
  showconfirmModal: boolean = false;
  isRemoving: boolean;
  deleteType: any;
  successMessage: string;
  errorMessage = this.constants.ERROR_TXT;
  videoDetails: string;
  checked: boolean = false;
  pageLoad: boolean = true;
  showCount: boolean = true;
  uploadedVideosCount = 0;
  sheetData: any[];
  constructor(
    public constants: ConstantsService,
    public adminService: AdminService,
    private dataService: DataService,
    private urlConstants: UrlConstants,
    private fb: UntypedFormBuilder
  ) {
    this.skeltonArray = this.constants.COUNTRY_LIST_TXT
  }

  ngOnInit(): void {
    this.onLoad();
  }
  onLoad = async () => {
    await this.adminService.getItemsFromSheetOnFirstLoad()
      .then(async res => {
        res['res']['sheetNames'].filter((ele, i) => {
          if (ele == 'F5 Responses') {
            res['res']['sheetNames'].splice(i, 1);
          }
        });
        this.sheetSelected = res['res']['sheetNames'][0];
        this.availableSheets = res['res']['sheetNames'];
        this.videoList = [];
        res['res'] = await this.formatTags(res['res']['formatedData']);
        this.videoList = res['res']
        this.videoList.forEach(element => {
          if (element.videoLink === undefined || element.videoLink === '') {
            element['error'] = 'Video link not Provided';
          } else if (element.videoLink.split('id=')[1] === undefined) {
            element['error'] = 'Invalid video link';
          } else {
            element['error'] = '';
            let videoId = element.videoLink.split('id=')[1];
            (element['thumbnail'] = `${this.constants.GCP_URL}${videoId}=w640`);
            element['videoId'] = videoId;
          }
        });
        this.isLoading = false;
        this.enableDelete = false;
      })
  }
  intialiseForm = (author, city, country) => {
    this.uploadSubmit = this.fb.group({
      author: [author, Validators.required],
      city: [city, Validators.required],
      country: [country, Validators.required],
      tags: [this.tag],
    });
  }
  getItems = sheet => {
    this.adminService
      .getItemsFromSheet(sheet)
      .then(async data => {
        await this.getAllData(data);
        this.isLoading = false;
        this.enableDelete = false;
        this.sheetSelected = sheet;
      }).catch(err => {
        this.isLoading = false;
      })
  }
  formatTags = data => {
    data.forEach(element => {
      element.tags.forEach(item => {
        if (item.status === 'FALSE' || item.status === undefined) item['status'] = false;
        else if (item.status === 'TRUE') item['status'] = true;
      });
    });
    return data;
  }
  getAllData = async data => {
    if (this.showSuccessMessage) {
      this.displaySuccessMessageDiv = true;
    }
    this.rowIndexArray = [];
    this.videoList = [];
    data['res'] = this.formatTags(data['res']);
    this.videoList = data['res'];
    this.videoList.forEach((element) => {
      if (element.videoLink === undefined || element.videoLink === '') {
        element['error'] = 'Video link not Provided';
      } else if (element.videoLink.split('id=')[1] === undefined) {
        element['error'] = 'Invalid video link';
      } else {
        element['error'] = '';
        let videoId = element.videoLink.split('id=')[1];
        (element['thumbnail'] = `${this.constants.GCP_URL}${videoId}=w640`);
        element['videoId'] = videoId;
      }
    });
    this.sheetData = this.videoList;
    setTimeout(() => {
      this.closeSuccessAlert();
    }, 7000);
    return await this.videoItem;
  }
  selectSheet = async sheet => {
    this.isLoading = true;
    await this.getItems(sheet);
    this.enableDelete = false;
    this.showSuccessMessage = false;
  };
  openVideo = async videoItem => {
    this.videoItem = videoItem;
    this.showVideo = true;
    this.uploadStatus = null;
    let videoId = videoItem.videoLink.split('id=')[1];
    this.videoId = videoItem.videoId;
    this.selectedUrl = `${this.constants.GOOGLE_DRIVE_API_IFRAME_URL}${videoId}/preview`;
    this.selectedAuthor = videoItem.author;
    this.selectedCity = videoItem.city;
    this.selectedCountry = videoItem.country;
    this.selectedMessage = videoItem.message === '' ? 'No Message are submitted by submitter' : videoItem.message;
    this.selectedEmail = videoItem.email;
    this.seletecDateUploaded = videoItem.dateSubmitted.split(' ')[0];
    this.tags = videoItem.tags;
    // converting into tag format in component
    this.tags.forEach((element) => this.tag[element['name']] = element['status']);
    this.rowIndex = videoItem.rowIndex;
    this.intialiseForm(
      this.selectedAuthor,
      this.selectedCity,
      this.selectedCountry
    );
    this.clickedDeleteButton = false;
    this.rowIndexArray = [];
  };
  onClickEditTitle = () => this.editTitle = true;
  onClickDoneEdit = async () => {
    this.savingEditedData = true;
    const postdata = {
      rowIndex: this.rowIndex,
      sheetName: this.sheetSelected,
      author: this.uploadSubmit.value.author,
      city: this.uploadSubmit.value.city,
      country: this.uploadSubmit.value.country,
      tags: this.uploadSubmit.value.tags,
    };
    this.selectedAuthor = this.uploadSubmit.value.author;
    this.selectedCity = this.uploadSubmit.value.city;
    this.selectedCountry = this.uploadSubmit.value.country;
    await this.adminService
      .addItemsToSheet(postdata)
      .then(async data => {
        this.videoItem = data['res'][this.rowIndex];
        this.showSuccessMessage = true;
        this.videoDetails = `${this.videoItem.author} - ${this.videoItem.city} , ${this.videoItem.country}`
        this.successMessage = this.constants.YOUR_TXT;
        await this.getAllData(data);
        this.isLoading = false;
        this.savingEditedData = false;
        this.editTitle = false;
        this.showVideo = true;
        this.enableDelete = false;
      }).catch(err => {
        this.showErrorMessage = true;
        this.errorMessage = this.constants.ERROR_TXT;
        setTimeout(() => {
          this.closeErrorAlert();
        }, 5000);
      })
  }
  onClose = () => {
    this.editTitle = false;
    this.showVideo = false;
    this.uploadingToVimeo = false;
  }
  cancelClick = () => {
    this.editTitle = false;
    this.tags = this.videoItem.tags;
    this.openVideo(this.videoItem);
  }
  tagChange = (event, item) => this.tag[item['name']] = event.target.checked;

  deletedata = async () => {
    this.isRemoving = true;
    const postdata = {
      rowIndex: this.rowIndexArray,
      sheetName: this.sheetSelected,
      moveTo: this.constants.UNFIT_VIDEOS_TXT,
    };
    this.rowIndexArray.forEach(element => {
      document.getElementById(`card${element}`).style.opacity = "50%"
    });
    await this.adminService
      .deleteItemsToSheet(postdata)
      .then(async res => {
        this.isLoading = false;
        this.showVideo = false;
        this.isRemoving = false;
        this.showconfirmModal = false;
        this.showSuccessMessage = true;
        this.clickedDeleteButton = false;
        await this.getItems(this.sheetSelected);
      }).catch(err => {
        this.showVideo = false;
        this.isRemoving = false;
        this.showconfirmModal = false;
        this.showErrorMessage = true;
        this.errorMessage = this.constants.ERROR_TXT;

        this.rowIndexArray.forEach(element => {
          document.getElementById(`card${element}`).style.opacity = "100%"
        });
        setTimeout(() => {
          this.closeErrorAlert();
        }, 5000);
      })
  }
  enabledelete = (event, item) => {
    this.enableDelete = true;
    if (event.target.checked) this.rowIndexArray.push(item.rowIndex);
    else {
      let removeIndex = this.rowIndexArray.findIndex(data => data === item.rowIndex);
      if (removeIndex !== -1) this.rowIndexArray.splice(removeIndex, 1);
    }
    this.videoDetails = '';
    this.successMessage = this.constants.DELETED_TXT;
    if (this.rowIndexArray.length === 0) {
      this.enableDelete = false;
      this.rowIndexArray = [];
    }
    if (this.rowIndexArray.length > 3) {
      this.showErrorMessage = true;
      this.errorMessage = this.constants.GOOGLE_API_ERROR_TXT;
      this.maxLimitReached = true;
      return;
    } else {
      this.maxLimitReached = false;
      this.closeErrorAlert();
    }
  }
  uploadToVimeo = async () => {
    if (this.videoItem != undefined) {
      this.uploadingToVimeo = true;
      this.uploadStatus = 'Initiated'
      const postParams = [
        { param: '{actionName}', value: 'upload' }
      ];
      const postdata = {
        url: `${this.constants.GOOGLE_DRIVE_API}${this.videoItem.videoId}?key=${environment.GDRIVE_API_KEY}&alt=media`,
        author: this.videoItem.author,
        city: this.videoItem.city,
        country: this.videoItem.country
      };
      await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, postParams), postdata)
        .subscribe(async (res) => {
          let videoId = res['res']['uri'].split('/videos/')[1]
          this.uploadStatus = res['res']['upload']['status']
          let interval = setInterval(async () => {
            let postParams = [
              { param: '{actionName}', value: 'getUploadStatus' }
            ];
            let postdata = { videoid: videoId }
            await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, postParams), postdata)
              .subscribe(async (res) => {
                this.uploadStatus = res['res']['upload']['status']
                if (res['res']['upload']['status'] == "complete") {
                  clearInterval(interval);
                  // inside post data url 1 is passing just as a key but te value is video submitted date
                  const postdata = {
                    "campaignId": "window",
                    "author": this.videoItem.author,
                    "cityLocation": this.videoItem.city + " - " + this.videoItem.country,
                    "videoId": res['res']['link'],
                    "City": this.videoItem.tags[5].status,
                    "Animals": this.videoItem.tags[0].status,
                    "DayVideo": this.videoItem.tags[4].status,
                    "emailId": this.videoItem.email,
                    "Interiors": this.videoItem.tags[7].status,
                    "Water" : this.videoItem.tags[8].status,
                    "Nature": this.videoItem.tags[3].status,
                    "Night": this.videoItem.tags[6].status,
                    "Rain": this.videoItem.tags[1].status,
                    "Snow": this.videoItem.tags[2].status,
                    "url1": await this.formattedDate(this.videoItem.dateSubmitted),
                    "videoType": { "sheetName": this.sheetSelected, "rowIndex": [this.rowIndex], "moveTo": this.constants.UPLOADED_VIDEO_TXT },
                    "thumbnail": res['res']['pictures']['sizes']['2']['link']
                  }
                  await this.adminService
                    .postToVimeo(postdata)
                    .then(async res => {
                      this.uploadedVideosCount++;
                      this.uploadingToVimeo = false;
                      this.showVideo = false;
                      this.showSuccessMessage = true;
                      this.videoDetails = `${postdata.author} - ${postdata.cityLocation} `
                      this.successMessage = this.constants.WINDOW_UPLOADED_TO_VIMEO_TXT;
                      await this.getItems(this.sheetSelected);
                    }).catch(err => {
                      this.showErrorMessage = true;
                      this.errorMessage = this.constants.ERROR_TXT;
                      this.uploadingToVimeo = false;
                      this.showVideo = false;
                      setTimeout(() => {
                        this.closeErrorAlert();
                      }, 5000);
                    })
                }
                if (res['res']['status'] == "uploading_error") {
                  console.log("Uploading Error", res);
                  this.uploadStatus = res['res']['status']
                  clearInterval(interval);
                  this.showVideo = false;
                  this.showErrorMessage = true;
                  this.uploadingToVimeo = false;
                  this.errorMessage = this.constants.ERROR_TXT;
                  setTimeout(() => {
                    this.closeErrorAlert();
                  }, 5000);
                }
              })
          }, 10000);

        })

    }
  }
  formattedDate = date => {
    let month;
    let fullDate;
    let splittedDate = date.split(' ')[0].split('/');
    let monthNum = Number(splittedDate[0]);
    this.constants.MONTHS_LIST.filter((data, index) => {
      if (monthNum === index + 1) {
        month = data.toString();
        fullDate = month + ' ' + splittedDate[1] + ' ' + splittedDate[2];
      }
    });
    return fullDate;
  }
  deleteSingleVideo = async () => {
    if (this.videoItem != undefined) {
      this.clickedDeleteButton = true;
      this.rowIndexArray.push(this.videoItem.rowIndex);
      this.videoDetails = `${this.videoItem.author} - ${this.videoItem.city} , ${this.videoItem.country}`;
      this.successMessage = this.constants.DELETED_TXT_SINGLE;
      await this.deletedata()
    } else {
      this.clickedDeleteButton = false;
      this.rowIndexArray = [];
    }
  }
  Search() {
    if (this.filteredString === '') {
      this.videoList = this.sheetData;
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 3000);
    }
    else {
      this.videoList = this.videoList.filter(res => {
        return res.country.toLowerCase().match(this.filteredString.toLowerCase());
      })
    }
  }
  closeErrorAlert() {
    this.showErrorMessage = false;
  }
  closeSuccessAlert() {
    this.displaySuccessMessageDiv = false;
  }
  onClickCloseConfirmPopup() {
    this.showconfirmModal = false;
  }

  onClickShowConfirmPopup(type) {
    this.deleteType = type;
    this.showconfirmModal = true;
  }
}
